import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Techs from "@/components/Techs";
import BrandingTab from "@/components/admin/BrandingTab";
import MenuTab from "@/components/admin/MenuTab";
import InvoicesTab from "@/components/admin/InvoicesTab";
import DatabasesTab from "@/components/admin/DatabasesTab";
import { setUiCache } from "@/lib/uiSettings";

const TABS = [["branding", "Branding"], ["users", "Users & access"], ["menu", "Menu"], ["invoices", "Invoices & email"], ["databases", "Databases"]];

export default function AdminPanel() {
  const [ui, setUi] = useState(null);
  const [tab, setTab] = useState(() => sessionStorage.getItem("admin-tab") || "branding");
  useEffect(() => { api.get("/ui-settings").then((r) => setUi(r.data)).catch((e) => toast.error(formatError(e))); }, []);

  const saveUi = async (next) => {
    try {
      const { data } = await api.put("/ui-settings", next);
      setUi(data); setUiCache(data);
      toast.success("Saved");
    } catch (e) { toast.error(formatError(e)); }
  };

  return (
    <div className="fade-up space-y-6" data-testid="admin-panel">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-cyan-400">Admin control panel</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-2">Admin panel</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">Change how the app looks, who can use what, the menu, invoice details and your databases.</p>
      </div>
      <Tabs value={tab} onValueChange={(t) => { setTab(t); sessionStorage.setItem("admin-tab", t); }}>
        <TabsList className="flex-wrap h-auto" data-testid="admin-tabs">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <div className="mt-6">
          {!ui ? <Loader2 className="animate-spin text-primary" /> : <>
            <TabsContent value="branding"><BrandingTab ui={ui} onSave={saveUi} /></TabsContent>
            <TabsContent value="users"><Techs /></TabsContent>
            <TabsContent value="menu"><MenuTab ui={ui} onSave={saveUi} /></TabsContent>
            <TabsContent value="invoices"><InvoicesTab /></TabsContent>
            <TabsContent value="databases"><DatabasesTab /></TabsContent>
          </>}
        </div>
      </Tabs>
    </div>
  );
}
